var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.41406,
    width: 23,
    height: 23,
    rx: 7.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4.41406C7.27614 4.41406 7.5 4.63792 7.5 4.91406V7.41406H10C10.2761 7.41406 10.5 7.63792 10.5 7.91406C10.5 8.1902 10.2761 8.41406 10 8.41406H7.5V10.9141C7.5 11.1902 7.27614 11.4141 7 11.4141C6.72386 11.4141 6.5 11.1902 6.5 10.9141V8.41406H4C3.72386 8.41406 3.5 8.1902 3.5 7.91406C3.5 7.63792 3.72386 7.41406 4 7.41406H6.5V4.91406C6.5 4.63792 6.72386 4.41406 7 4.41406ZM19.3536 5.56051C19.5488 5.75577 19.5488 6.07235 19.3536 6.26762L5.35355 20.2676C5.15829 20.4629 4.84171 20.4629 4.64645 20.2676C4.45118 20.0724 4.45118 19.7558 4.64645 19.5605L18.6464 5.56051C18.8417 5.36525 19.1583 5.36525 19.3536 5.56051ZM13.5 18.9141C13.5 18.6379 13.7239 18.4141 14 18.4141H20C20.2761 18.4141 20.5 18.6379 20.5 18.9141C20.5 19.1902 20.2761 19.4141 20 19.4141H14C13.7239 19.4141 13.5 19.1902 13.5 18.9141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorIcon);
export default __webpack_public_path__ + "static/media/CalculatorIcon.46542817915fb5a5d00800d04ca797f3.svg";
export { ForwardRef as ReactComponent };